export default __webpack_public_path__ + "static/DesktopMediaMainBanner-6f91f0c0a97e186a022a6c932952ba34.png";